import { render } from "./client_block.vue?vue&type=template&id=005f1b9a"
import script from "./client_block.vue?vue&type=script&lang=js"
export * from "./client_block.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__